import { HebrewCalendar } from '@hebcal/core';

/**
 * Compute hallel status for a given date.
 *
 * HebrewCalendar.hallel() returns: 0=none, 1=half, 2=full.
 * We add manual overrides for:
 *  - Shmini Atzeret / Simchat Torah (hebcal bug: desc "Shmini Atzeret" doesn't startsWith "Sukkot")
 *  - Modern holidays (configurable)
 *
 * @param {HDate} hdate
 * @param {boolean} isIsrael
 * @param {object} config - engine config (yomHaatzmautHallel, yomYerushalayimHallel)
 * @returns {{ type: string, reason: string|null }}
 */
export function computeHallel(hdate, isIsrael, config) {
  const m = hdate.getMonth();
  const d = hdate.getDate();

  // ── Manual overrides (hebcal gaps) ──

  // Shmini Atzeret (22 Tishrei) — full hallel
  // Hebcal's hallel_() misses this because desc is "Shmini Atzeret" not "Sukkot..."
  if (m === 7 && d === 22) {
    return { type: 'full', reason: 'שמיני עצרת' };
  }
  // Simchat Torah (23 Tishrei, diaspora only) — full hallel
  if (!isIsrael && m === 7 && d === 23) {
    return { type: 'full', reason: 'שמחת תורה' };
  }

  // Modern holidays — configurable
  if (m === 2 && d === 5) {
    if (config.yomHaatzmautHallel) return { type: 'full', reason: 'יום העצמאות' };
    // If config says no hallel, skip hebcal's result (which returns full)
    return { type: 'none', reason: null };
  }
  if (m === 2 && d === 28) {
    if (config.yomYerushalayimHallel) return { type: 'full', reason: 'יום ירושלים' };
    return { type: 'none', reason: null };
  }

  // ── Delegate to hebcal for everything else ──
  const hal = HebrewCalendar.hallel(hdate, isIsrael);

  if (hal === 2) return { type: 'full', reason: getHallelReason(hdate, isIsrael) };
  if (hal === 1) return { type: 'half', reason: getHallelReason(hdate, isIsrael) };
  return { type: 'none', reason: null };
}

function getHallelReason(hdate, isIsrael) {
  const m = hdate.getMonth();
  const d = hdate.getDate();

  // Sukkot (15-21 Tishrei — 22+ handled by manual overrides above)
  if (m === 7 && d >= 15 && d <= 21) return 'סוכות';

  // Chanukah (25 Kislev - 2/3 Tevet)
  if (m === 9 && d >= 25) return 'חנוכה';
  if (m === 10 && d <= 3) return 'חנוכה';

  // Pesach (15-21 Nisan IL, 15-22 diaspora)
  if (m === 1 && d >= 15 && d <= (isIsrael ? 21 : 22)) return 'פסח';

  // Shavuot
  if (m === 3 && d >= 6 && d <= (isIsrael ? 6 : 7)) return 'שבועות';

  // Rosh Chodesh
  if (d === 1 || d === 30) return 'ר״ח';

  return null;
}
